module.exports = __webpack_public_path__ + "static/media/st.2eb11f63.svg";